<script>
/* eslint-disable */
import gsap from 'gsap'
import drawSVG from 'gsap/DrawSVGPlugin'

export default {
  props: {
    boxColor: {
      type: String,
      default: 'blue',
    },
    posOrient: {
      type: String,
      default: 'bottom-right',
    },
    hotspotId: {
      type: String,
      default: 'hotspoty',
    },
    hotspotClass: {
      type: String,
      default: 'hotspoty',
    },
    idName: {
      type: String,
      default: 'box',
    },
    className: {
      type: String,
      default: 'c-box',
    },
    durationConnector: {
      type: Number,
      default: 2.5,
    },
    delayStart: {
      type: Number,
      default: 2,
    },
    delayOuter: {
      type: Number,
      default: -0.125,
    },
    durationOuter: {
      type: Number,
      default: 0.6,
    },
    delayInnerOrigin: {
      type: Number,
      default: -0.5,
    },
    durationInnerOrigin: {
      type: Number,
      default: 0.5,
    },
    delayBackground: {
      type: Number,
      default: 0.125,
    },
    durationBackground: {
      type: Number,
      default: 0.75,
    },
    delayInnerOpposite: {
      type: Number,
      default: 0.125,
    },
    durationInnerOpposite: {
      type: Number,
      default: 0.5,
    },
    contentChildrenY: {
      type: String,
      default: '0.75rem',
    },
    delayContentChildren: {
      type: Number,
      default: -0.125,
    },
    staggerContentChildren: {
      type: Number,
      default: 0.15,
    },
    durationContentChildren: {
      type: Number,
      default: 0.2,
    },
    position: {
      type: Array,
      default: () => [200, 100],
    },
    originish: {
      type: Array,
      default: () => [550, 400],
    },
    target: {
      type: Boolean,
      default: false,
    },
    hotSpotX: {
      type: Number,
      default: 0,
    },
    hotSpotY: {
      type: Number,
      default: 0,
    },
    hotSpotUnit: {
      type: String,
      default: '%',
    },
  },
  created() {
    window.addEventListener('resize', this.windowResize)
  },
  computed: {
    drawInnerLines() {
      if (this.posOrient === 'bottom-right') {
        return '<line x1="100%" x2="0" y1="0" y2="0" /> <line x1="100%" x2="100%" y1="2rem" y2="100%" /> <line x1="0" x2="2rem" y1="2rem" y2="0" /> <line x1="100%" x2="2rem" y1="100%" y2="100%" /> <line x1="0" x2="0" y1="0" y2="100%" />'
      } else if (this.posOrient === 'bottom-left') {
        return '<line x1="100%" x2="0" y1="0" y2="0" /> <line x1="100%" x2="100%" y1="2rem" y2="100%" /> <line x1="0" x2="2rem" y1="2rem" y2="0" /> <line x1="2rem" x2="100%" y1="100%" y2="100%" /> <line x1="0" x2="0" y1="100%" y2="0" />'
      } else if (this.posOrient === 'top-left') {
        return '<line x1="0" x2="100%" y1="0" y2="0" /> <line x1="100%" x2="100%" y1="100%" y2="2rem" /> <line x1="2rem" x2="0" y1="0" y2="2rem" /> <line x1="100%" x2="2rem" y1="100%" y2="100%" /> <line x1="0" x2="0" y1="0" y2="100%" />'
      } else if (this.posOrient === 'top-right') {
        return '<line x1="100%" x2="0" y1="0" y2="0" /> <line x1="100%" x2="100%" y1="2rem" y2="100%" /> <line x1="0" x2="2rem" y1="2rem" y2="0" /> <line x1="2rem" x2="100%" y1="100%" y2="100%" /> <line x1="0" x2="0" y1="100%" y2="0" />'
      } else {
        return '<line x1="100%" x2="0" y1="100%" y2="100%" /><line x1="0" x2="0" y1="100%" y2="0" />'
      }
    },
    drawOuterLines() {
      if (this.posOrient === 'bottom-right') {
        return '<line x1="100%" x2="0" y1="100%" y2="100%" /><line x1="0" x2="0" y1="100%" y2="0" />'
      } else if (this.posOrient === 'bottom-left') {
        return '<line x1="0" x2="100%" y1="100%" y2="100%" /><line x1="0" x2="0" y1="100%" y2="0" /> '
      } else if (this.posOrient === 'top-left') {
        return '<line x1="0" x2="100%" y1="0" y2="0" /><line x1="0" x2="0" y1="0" y2="100%" />'
      } else if (this.posOrient === 'top-right') {
        return '<line x1="100%" x2="0" y1="0" y2="0" /><line x1="100%" x2="100%" y1="0" y2="100%" />'
      } else {
        return '<line x1="100%" x2="0" y1="100%" y2="100%" /><line x1="0" x2="0" y1="100%" y2="0" />'
      }
    },
    drawConnectLines() {
      if (this.posOrient === 'bottom-right') {
        return '<line x1="100%" x2="0" y1="100%" y2="0" />'
      } else if (this.posOrient === 'bottom-left') {
        return '<line x1="0" x2="100%" y1="100%" y2="0" />'
      } else if (this.posOrient === 'top-left') {
        return '<line x1="0" x2="100%" y1="0" y2="100%" />'
      } else if (this.posOrient === 'top-right') {
        return '<line x1="100%" x2="0" y1="0" y2="100%" />'
      } else {
        return '<line x1="0" x2="100%" y1="0" y2="100%" />'
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.initBox()
        .setPositionOrientation()
        .drawConnectorLine()
        .createTheSacredTimeline()
        .animate()
    }, this.delayStart)
  },
  methods: {
    hotSpotStyle() {
      return (
        'top: ' +
        this.hotSpotY +
        this.hotSpotUnit +
        '; left: ' +
        this.hotSpotX +
        this.hotSpotUnit +
        ';'
      )
    },
    initBox() {
      // Make sure GSAP is always looking gawgeous
      gsap.registerPlugin(drawSVG)
      gsap.config({ force3D: true })

      // Set all those pesky elements
      this.box = document.getElementById(this.idName)

      this.background = this.box.getElementsByClassName(
        `${this.className}__background`
      )

      this.contentChildren = this.box.getElementsByClassName(
        `${this.className}__content`
      )[0].children

      this.lines = this.box.getElementsByTagName('line')

      this.lineInnerTop = this.lines[0]
      this.lineInnerRight = this.lines[1]
      this.lineInnerBevel = this.lines[2]
      this.lineInnerBottom = this.lines[3]
      this.lineInnerLeft = this.lines[4]
      this.lineOuterX = this.lines[5]
      this.lineOuterY = this.lines[6]
      this.lineConnector = this.lines[7]

      this.lineConnectorSVG = this.box.getElementsByClassName(
        `${this.className}__connector-line`
      )[0]

      // Now, reset the box visually
      // Here is also the right time to calculate positions and oriantations as well as set up the connector line

      gsap.set(this.lines, { drawSVG: false })
      gsap.set(this.background, { opacity: 0 })
      gsap.set(this.contentChildren, {
        y: this.contentChildrenY,
        opacity: 0,
      })
      gsap.set(this.box, { visibility: 'visible' })

      //this.setPositionOrientation()
      //this.drawConnectorLine()

      return this
    },

    // Sets the box's position and orientation
    // Computes the distance between the box and the origin, then determines the best orientation from that info
    // There's probbaly room to cache some of this for performance once we get more into animations

    setPositionOrientation() {
      // The origin is the center of the target element with the reference to it

      gsap.set(this.box, { x: this.position[0], y: this.position[1] })

      const targetRect = document
        .getElementById(this.hotspotId)
        .getBoundingClientRect()

      console.log(targetRect)

      this.origin = [
        targetRect.left + targetRect.width / 2,
        targetRect.top + targetRect.height / 2,
      ] // X, Y

      // If the origin isn't specifically passed, we can figure it out pretty reliably

      if (!this.orientation) {
        this.boxRect = this.box.getBoundingClientRect()
        this.boxCenter = [
          this.boxRect.left + this.boxRect.width / 2,
          this.boxRect.left + this.boxRect.height / 2,
        ] // X, Y

        this.orientation = [
          this.boxCenter[1] - this.origin[1] > 0 ? 'bottom' : 'top',
          this.boxCenter[0] - this.origin[0] > 0 ? 'left' : 'right',
        ] // Y, X
      }

      // Set inner line groups based on orientation
      // Yes this looks dumb, but only because I can't assume we're using jQuery

      this.linesInnerOrigin = [
        this.orientation[0] === 'top'
          ? this.lineInnerTop
          : this.lineInnerBottom,
        this.orientation[1] === 'right'
          ? this.orientation[0] === 'top'
            ? this.lineInnerRight
            : this.lineInnerBevel
          : this.lineInnerLeft,
      ]

      this.linesInnerOpposite = [
        this.orientation[0] === 'top'
          ? this.lineInnerBottom
          : this.lineInnerTop,
        this.orientation[1] === 'right'
          ? this.lineInnerLeft
          : this.lineInnerRight,
        this.orientation[0] === 'top' || this.orientation[1] === 'left'
          ? this.lineInnerBevel
          : this.lineInnerRight,
      ]

      /*
      this.box.classList.add(
        `${this.className}--${this.orientation[0]}-${this.orientation[1]}`
      )
*/
      //console.log()

      return this
    },

    // Draws the connector line
    // Given what we know about the box & origin's positions, we can calculate how long the connectr line should be

    drawConnectorLine() {
      // We can figure out where the relevant corner of the connecting line is depending on orientation
      // We may want to find a nice way to cache this for performance once we get into animations

      const connectorLineRect = this.lineConnectorSVG.getBoundingClientRect()
      const cornerPosition = [
        this.orientation[1] === 'right'
          ? connectorLineRect.left
          : connectorLineRect.right,
        this.orientation[0] === 'top'
          ? connectorLineRect.bottom
          : connectorLineRect.top,
      ] // X, Y

      // Now, we can set the height and width of the connector!
      // At this point, it should just the (absolute) difference between these corner coordinates to the origin coordinates

      const connectorWidth = Math.abs(cornerPosition[0] - this.origin[0])
      const connectorHeight = Math.abs(cornerPosition[1] - this.origin[1])
      gsap.set(this.lineConnectorSVG, {
        width: connectorWidth,
        height: connectorHeight,
      })
      console.log(this.box)

      return this
    },

    createTheSacredTimeline() {
      this.inOutTimeline = gsap
        .timeline({ paused: true })
        .addLabel('connector')
        .to(this.lineConnector, {
          drawSVG: true,
          duration: this.durationConnector,
        })
        .addLabel('outer')
        .to(
          [this.lineOuterX, this.lineOuterY],
          { drawSVG: true, duration: this.durationOuter },
          `>${this.delayOuter}`
        )
        .addLabel('innerOrigin', `>${this.delayInnerOrigin}`)
        .to(
          this.linesInnerOrigin,
          { drawSVG: true, duration: this.durationInnerOrigin },
          'innerOrigin'
        )
        .addLabel('background')
        .to(
          this.background,
          { opacity: 1 },
          `innerOrigin+=${this.delayBackground}`
        )
        .addLabel('innerOpposite')
        .to(
          this.linesInnerOpposite,
          { drawSVG: true },
          `innerOrigin+=${this.delayInnerOpposite}`
        )
        .addLabel('contentChildren', `>${this.delayContentChildren}`)
        .to(
          this.contentChildren,
          {
            y: 0,
            opacity: 1,
            stagger: this.staggerContentChildren,
            duration: this.durationContentChildren,
          },
          'content'
        )

      console.log('Animate Timelines')

      return this
    },
    animate(isIn = true) {
      if (isIn) {
        this.inOutTimeline.restart()
      } else {
        this.inOutTimeline.reversed(true)
      }

      console.log('Run Animations')

      return this
    },
    windowResize(e) {
      this.setPositionOrientation().drawConnectorLine()
    },
  },
}
</script>

<template>
  <div>
    <div
      :id="idName"
      ref="boxy"
      :class="[
        className,
        className + '--' + posOrient,
        'c-box',
        'c-box--' + posOrient,
      ]"
    >
      <div
        ref="boxyBg"
        :class="['c-box__background', className + '__background', boxColor]"
      ></div>

      <div
        ref="boxyContent"
        :class="['c-box__content', className + '__content']"
      >
        <slot />
      </div>

      <svg
        ref="boxyInnerLine"
        :class="['c-box__inner-line', className + '__inner-line']"
        v-html="drawInnerLines"
      ></svg>

      <svg
        :class="['c-box__outer-line', className + '__outer-line']"
        v-html="drawOuterLines"
      ></svg>

      <svg
        ref="boxyConnectorLine"
        :class="['c-box__connector-line', className + '__connector-line']"
        v-html="drawConnectLines"
      ></svg>
    </div>

    <div
      :id="hotspotId"
      :class="['c-hotspot', hotspotClass]"
      :style="hotSpotStyle()"
    ></div>
  </div>
</template>

<style lang="scss">
@import '@design';

/* stylelint-disable */
.c-box {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  display: inline-block;
}

.c-box__background,
.c-box__content {
  clip-path: polygon(
    0 0,
    0 0,
    0 0,
    100% 0,
    100% calc(100% - 2rem),
    calc(100% - 2rem) 100%,
    0 100%,
    0 0
  ); /* cornerOffset */
}

.c-box__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.blue {
    background-color: rgba(1, 73, 105);
  }

  &.white {
    background-color: rgba(255, 255, 255, 0.25);
    backdrop-filter: brightness(72.5%) blur(5px);
  }

  &.black {
    background-color: rgba(0, 0, 0, 1);
  }
}

.c-box__content {
  position: relative;
  z-index: 20;
  padding: 2rem 2.5rem 2rem 2rem;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.7);
}

/* All SVGs and SVG lines */

/* vector-effect forces the stroke to be in pixel space */

/* We'd need to handle the different line orientation */

/* We could set intelligently with JS depending on box & hotspot position */

.c-box svg {
  overflow: visible;
}

.c-box line {
  stroke: white;
  stroke-width: 1.666;
  vector-effect: non-scaling-stroke;
}

.c-box__inner-line,
.c-box__outer-line,
.c-box__connector-line {
  position: absolute;
  z-index: 1;
}

/* The inner line */

/* Plain 'ol transforms are used to offset shortcomings of top-left SVG origin */

.c-box__inner-line {
  top: 0;
  width: 100%;
  height: 100%;
}

.c-box__inner-line line:nth-child(2) {
  transform: translate(0, -2rem); /* cornerOffset */
}

.c-box__inner-line line:nth-child(3) {
  transform: translate(calc(100% - 2rem), calc(100% - 2rem)); /* cornerOffset */
}

.c-box__inner-line line:nth-child(4) {
  transform: translate(-2rem, 0); /* cornerOffset */
}

/* The outer line */

.c-box__outer-line {
  top: 0;
  left: -1rem; /* outerOffset */
  width: calc(100% + 1rem - 2rem); /* outerOffset, cornerOffset */
  height: calc(100% + 1rem); /* outerOffset */
}

.c-box--top-left .c-box__outer-line,
.c-box--top-right .c-box__outer-line {
  top: -1rem; /* outerOffset */
  width: calc(100% + 1rem); /* outerOffset, cornerOffset */
}

.c-box--top-right .c-box__outer-line {
  left: 0;
  height: calc(100% - 1rem); /* cornerOffset */
}

/* The connector line */

/* Eventual width and height determined by JS */

.c-box__connector-line {
  top: calc(100% + 1rem); /* outerOffset */
  right: calc(100% + 1rem); /* outerOffset */
  width: 0px;
  height: 0px;
}

.c-box--top-left .c-box__connector-line,
.c-box--top-right .c-box__connector-line {
  top: auto;
  bottom: calc(100% + 1rem); /* outerOffset */
}

.c-box--top-right .c-box__connector-line,
.c-box--bottom-right .c-box__connector-line {
  right: auto;
}

.c-box--top-right .c-box__connector-line {
  left: calc(100% + 1rem); /* outerOffset */
}

.c-box--bottom-right .c-box__connector-line {
  left: calc(100% - 2rem); /* cornerOffset */
}

/* The test hotspot */

.c-hotspot {
  position: absolute;
  z-index: 10;
  top: 45%;
  left: 15%;
  width: 25px;
  height: 25px;
  background: transparent;
  border-radius: 50%;
}

/* stylelint-enable */
</style>
